<ngx-datatable
  class="bootstrap col-xl-12 col-12 col-lg-12 col-sm-12 col-md-12"
  [rows]="tableData"
  [columnMode]="'force'"
  [columns]="tableHeaders"
  [displayCheck]="displayCheck"
  [selectionType]="selectionType.checkbox"
  [selectAllRowsOnPage]="false"
  [headerHeight]="50"
  [footerHeight]="50"
  [rowHeight]="'auto'"
  [loadingIndicator]="true"
  (select)="onSelect($event)"
  [selected]="selected"
  (page)="onPaginate($event)"
  [messages]="{
    emptyMessage: 'Sem dados.',
    totalMessage: 'Total',
    selectedMessage: 'Selecionado'
  }"
  [limit]="tableLimit"
  [offset]="tableOffset"
  [count]="tableCount"
  [externalPaging]="externalPaging"
  (sort)="onSort($event)"
  [externalSorting]="externalPaging"
  [scrollbarH]="scrollBarHorizontal"
  #table
>
  <ng-container *ngFor="let column of tableHeaders; let i = index">
    <ngx-datatable-column
      *ngIf="
        column.prop !== 'actions' &&
        column.prop !== 'quantity' &&
        column.prop !== 'video' &&
        column.prop !== 'equipment' &&
        column.prop !== 'orderOwner' &&
        column.prop !== 'orderTitle' &&
        column.prop !== 'invoiceClient' &&
        column.prop !== 'operationType' &&
        column.prop !== 'ownerParent' &&
        column.prop !== 'paymentMethod'
      "
      [name]="column.name | translate"
      [prop]="column.prop"
      [headerCheckboxable]="false"
      [checkboxable]="i === -1"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <ng-container
          *ngIf="tableBadges && tableBadges.length > 0; else defaultColumn"
        >
          <ng-container *ngFor="let badge of tableBadges">
            <ng-container
              *ngIf="column.prop === badge.prop; else defaultColumn"
            >
              <div
                [ngClass]="{ 'deleted-row': row?.isDeleted }"
                [class]="getBadgeClass(badge, value)"
              >
                {{ getBadgeValue(badge, value) | translate }}
              </div>
              <div
                *ngIf="row?.innerFlowStatus?.internalStatus === 'OP_OPENED'"
                class="op-opened"
                [matTooltip]="'OP Opened' | translate"
              ></div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="tableIcons && tableIcons.length > 0">
            <ng-container *ngFor="let icon of tableIcons">
              <ng-container *ngIf="column.prop === icon.prop">
                <div class="table-icon">
                  <ng-container
                    *ngIf="
                      getIconName(icon, value) === 'icon-active';
                      else iconExpired
                    "
                  >
                    <svg
                      width="12"
                      height="16"
                      viewBox="0 0 12 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.1167 6.05833L6.05833 1L1 6.05833M6.05833 15.1667V1.14167"
                        stroke="#4FDB5B"
                        stroke-width="1.25"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </ng-container>
                  <ng-template #iconExpired>
                    <svg
                      width="12"
                      height="16"
                      viewBox="0 0 12 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.1167 10.1087L6.05833 15.167L1 10.1087M6.05833 1.00032V15.0253"
                        stroke="#FB273E"
                        stroke-width="1.25"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </ng-template>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #defaultColumn>
          <ng-container *ngIf="column.prop !== 'code'; else codeProp">
            <span
              [ngClass]="{ 'deleted-row': row?.isDeleted }"
              [innerHTML]="value"
            ></span>
          </ng-container>
          <ng-template #codeProp>
            <div
              class="code-prop"
              (mouseenter)="showImageOnMouseEnter($event)"
              (mouseleave)="removeImageOnMouseLeave($event)"
            >
              <span
                [ngClass]="{ 'deleted-row': row?.isDeleted }"
                [innerHTML]="value"
              ></span>
              <div *ngIf="row.image !== ''" class="code-img d-none">
                <div class="arow">
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.7121 8.23733C19.1188 8.99147 19.1188 11.0085 17.7121 11.7627L2.94498 19.6795C1.61263 20.3938 -9.80384e-07 19.4286 -9.14303e-07 17.9168L-2.22193e-07 2.08318C-1.56112e-07 0.571435 1.61263 -0.39378 2.94499 0.320508L17.7121 8.23733Z"
                    />
                  </svg>
                </div>
                <img class="img-fluid" [src]="row.image" alt="" />
              </div>
            </div>
          </ng-template>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      [name]="column.name | translate"
      [prop]="column.checkboxValue || ''"
      prop="quantity"
      class="actions-col"
      [sortable]="false"
      *ngIf="column.prop === 'quantity'"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="qty-box">
          <div
            class="input-group"
            [class]="
              mustDisableQuantityField(row) || row?.disabled ? 'disabled' : ''
            "
            [ngClass]="{ 'disabled-increase': row?.disabledIncreaseQuantity }"
          >
            <span
              [ngClass]="{ 'deleted-row': row?.isDeleted }"
              class="input-group-prepend decrease"
            >
              <button
                class="btn quantity-left-minus"
                type="button"
                data-type="minus"
                style="color: black"
                (click)="decreaseQuantity(row)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="feather feather-minus-square font-secondary"
                >
                  <rect width="20" height="20" rx="2" fill="#E2E5E9" />
                  <path
                    d="M14.2105 10.5789H5.78947C5.35789 10.5789 5 10.2211 5 9.78947C5 9.35789 5.35789 9 5.78947 9H14.2105C14.6421 9 15 9.35789 15 9.78947C15 10.2211 14.6421 10.5789 14.2105 10.5789Z"
                    fill="#647387"
                  />
                </svg>
              </button>
            </span>
            <input
              class="form-control input-number"
              type="text"
              name="quantity"
              [value]="value?.quantity || 0"
              (change)="changeQuantity(row, $event)"
              data-original-title=""
              title=""
              (keydown)="callCheckLength($event, inputText)"
              #inputText
            /><span
              [ngClass]="{ 'deleted-row': row?.isDeleted }"
              class="input-group-prepend increase"
            >
              <button
                class="btn quantity-right-plus"
                type="button"
                data-type="plus"
                (click)="increaseQuantity(row)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="feather feather-plus-square"
                >
                  <rect width="20" height="20" rx="2" fill="#E2E5E9" />
                  <path
                    d="M14.2105 9.21053H10.7895V5.78947C10.7895 5.35789 10.4316 5 10 5C9.56842 5 9.21053 5.35789 9.21053 5.78947V9.21053H5.78947C5.35789 9.21053 5 9.56842 5 10C5 10.4316 5.35789 10.7895 5.78947 10.7895H9.21053V14.2105C9.21053 14.6421 9.56842 15 10 15C10.4316 15 10.7895 14.6421 10.7895 14.2105V10.7895H14.2105C14.6421 10.7895 15 10.4316 15 10C15 9.56842 14.6421 9.21053 14.2105 9.21053Z"
                    fill="#647387"
                  />
                </svg>
              </button>
            </span>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      [name]="column.name | translate"
      [prop]="column.checkboxValue || ''"
      prop="actions"
      class="actions-col"
      [sortable]="false"
      *ngIf="column.prop === 'actions'"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <span
          [ngClass]="{ 'deleted-row': row?.isDeleted }"
          *ngFor="let action of tableActionIcons"
          class="buttons"
        >
          <ng-container *ngIf="action.icon">
            <ng-container
              *ngIf="action.value !== 'download'; else datasheetIcon"
            >
              <button
                [class]="action.value"
                mat-icon-button
                *ngIf="!action.tooltip"
              >
                <mat-icon
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  {{ action.icon }}
                </mat-icon>
              </button>
              <button
                mat-icon-button
                [class]="action.value"
                [matTooltip]="action.tooltip"
                *ngIf="action.tooltip"
              >
                <mat-icon
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  {{ action.icon }}
                </mat-icon>
              </button>
            </ng-container>
            <ng-template #datasheetIcon>
              <button mat-icon-button *ngIf="!action.tooltip">
                <mat-icon
                  *ngIf="!row.hasDatasheet"
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  block
                </mat-icon>
                <mat-icon
                  *ngIf="row.hasDatasheet"
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  {{ action.icon }}
                </mat-icon>
              </button>
              <button
                mat-icon-button
                [matTooltip]="action.tooltip"
                *ngIf="action.tooltip"
              >
                <mat-icon
                  *ngIf="!row.hasDatasheet"
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  block
                </mat-icon>
                <mat-icon
                  *ngIf="row.hasDatasheet"
                  class="font-primary"
                  [ngStyle]="{
                    'background-color': action.style?.background,
                    color: action.style?.color,
                    'font-size': action.style?.fontSize,
                    'font-weight': action.style?.fontWeight
                  }"
                  (click)="onClickIconAction(action.value, row)"
                >
                  {{ action.icon }}
                </mat-icon>
              </button>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="action.buttonLabel">
            <button
              mat-flat-button
              class="bg-primary rounded border-0 px-6 me-2"
              (click)="onClickIconAction(action.value, row)"
            >
              <p class="text-white fw-bold my-1">
                {{ action.buttonLabel | translate }}
              </p>
            </button>
          </ng-container>

          <ng-container
            *ngIf="
              action.checkbox &&
              column.checkboxValue !== null &&
              column.checkboxValue !== undefined
            "
          >
            <mat-checkbox
              [checked]="row[column.checkboxValue] !== 0"
              (change)="
                onClickCheckboxAction(action.value, row, $event.checked)
              "
            >
            </mat-checkbox>
          </ng-container>
        </span>
        <!--         <div
          *ngIf="row?.innerFlowStatus?.internalStatus === 'OP_OPENED'"
          class="op-opened"
          [matTooltip]="'OP Opened' | translate"
        ></div> -->
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      [name]="column.name | translate"
      [prop]="column.checkboxValue || ''"
      prop="video"
      class="video-col"
      [sortable]="false"
      *ngIf="column.prop === 'video'"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <span class="video-button">
          <ng-container>
            <button>
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="onClickVideo()"
              >
                <path
                  opacity="0.4"
                  d="M30.1226 17C30.1226 24.272 24.2279 30.1667 16.956 30.1667C9.68401 30.1667 3.78931 24.272 3.78931 17C3.78931 9.72808 9.68401 3.83337 16.956 3.83337C24.2279 3.83337 30.1226 9.72808 30.1226 17Z"
                  stroke="#CBCBDC"
                  stroke-width="2"
                />
                <path
                  d="M21.2078 14.4938L17.0994 12.128C16.0794 11.533 14.8469 11.533 13.8269 12.128C12.8069 12.723 12.1978 13.7713 12.1978 14.9613V19.7072C12.1978 20.883 12.8069 21.9455 13.8269 22.5405C14.3215 22.8286 14.8837 22.9804 15.4561 22.9804C16.0285 22.9804 16.5906 22.8286 17.0853 22.5405L21.1936 20.1747C22.2136 19.5797 22.8228 18.5313 22.8228 17.3413C22.8511 16.1513 22.2419 15.0888 21.2078 14.4938Z"
                  fill="#E05F57"
                />
              </svg>
            </button>
          </ng-container>
        </span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      *ngIf="column.prop === 'equipment'"
      [name]="column.name | translate"
      [prop]="column.prop"
      [headerCheckboxable]="false"
      [checkboxable]="i === -1"
      [sortable]="false"
      [width]="column.width"
      [headerTemplate]="customHeader"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <span
          [innerHTML]="value"
          [ngClass]="{ 'deleted-row': row?.isDeleted }"
          matTooltip="{{ value }}"
          *ngIf="value.length > 45"
        ></span>
        <span
          [ngClass]="{ 'deleted-row': row?.isDeleted }"
          [innerHTML]="value"
          *ngIf="value.length <= 45"
        ></span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      *ngIf="column.prop === 'operationType'"
      [name]="column.name | translate"
      [prop]="column.prop"
      [headerCheckboxable]="false"
      [sortable]="false"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div
          [ngClass]="
            value === 'INCOME' ? 'income custom-badge' : 'withdraw custom-badge'
          "
        >
          {{ value | translate }}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      *ngIf="
        column.prop === 'orderOwner' ||
        column.prop === 'orderTitle' ||
        column.prop === 'invoiceClient' ||
        column.prop === 'ownerParent'
      "
      [name]="column.name | translate"
      [prop]="column.prop"
      [headerCheckboxable]="false"
      [checkboxable]="i === -1"
      [sortable]="false"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <span
          [innerHTML]="value"
          matTooltip="{{ value }}"
          *ngIf="value.length > 15"
        ></span>
        <span [innerHTML]="value" *ngIf="value.length <= 15"></span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      *ngIf="column.prop === 'paymentMethod'"
      [name]="column.name | translate"
      [prop]="column.prop"
      [headerCheckboxable]="false"
      [checkboxable]="i === -1"
      [sortable]="false"
      [width]="column.width"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <span
          [class.financingDocument]="row?.showOtherFinancingMarker"
          [innerHTML]="value"
        ></span>
      </ng-template>
    </ngx-datatable-column>
    <ng-template #customHeader let-column="column">
      <span class="datatable-header-cell-label draggable me-4">{{
        column.name | translate
      }}</span>
      <div class="search d-flex align-items-center position-relative">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
            stroke="#647387"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.5 17.5L13.875 13.875"
            stroke="#647387"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <input
          id="search"
          type="text"
          (keyup)="filterData($event.target.value)"
          class="form-control"
          [placeholder]="'Search' | translate"
          aria-label="Search"
          aria-describedby="basic-addon1"
        />
      </div>
    </ng-template>
  </ng-container>
</ngx-datatable>
